import React from 'react'
import OutputReportPage from './OutputReportPage'

/**
 * SCR-M18-005 — Sản lượng & giờ định mức theo CÔNG ĐOẠN.
 *
 * Cùng dữ liệu với SCR-M18-001, đảo trục nhóm: dòng cha là công đoạn, dòng con là tài khoản. Trả lời
 * câu hỏi khác hẳn — "công đoạn nào đang gánh, ai đang gánh nó" thay vì "người này làm những gì".
 *
 * Là một lớp vỏ mỏng có CHỦ ĐÍCH, không phải bản sao: toàn bộ bộ lọc, dải KPI, 12 cột và các đường
 * khoan sâu nằm ở `OutputReportPage`. Tách thành file riêng là chép ~1.000 dòng rồi sửa một bên
 * quên bên kia.
 *
 * Danh sách các điểm rẽ theo `groupBy` nằm ở docblock của `OutputReportPage` — một chỗ duy nhất,
 * cố ý không nhắc lại ở đây.
 *
 * Route riêng chứ không phải nút gạt trên màn cũ: đây là một mục menu, và URL của nó chia sẻ được.
 */
export default function OutputByStagePage(props) {
    return <OutputReportPage {...props} groupBy="stage"/>
}
